import type { ElementType, HTMLAttributes, ReactElement } from "react";
import styles from "./VisuallyHidden.module.css";

export interface VisuallyHiddenProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
}

/**
 * Renders content that is invisible on screen but present in the accessibility
 * tree — for screen-reader-only labels, headings, and "opens in new tab" hints.
 */
export function VisuallyHidden({
  as: Component = "span",
  className,
  children,
  ...rest
}: VisuallyHiddenProps): ReactElement {
  const classes = [styles.visuallyHidden, className].filter(Boolean).join(" ");
  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
}
